'use strict'

export default class AuthenticationInterceptor {

    /* ngInject */
    constructor($q, $window, $location, $rootScope) {
        // this.$q = $q;
        // this.$window = $window;
     	this.responseError = (rejection) => {    	      
        if (rejection.status === 401 || rejection.status === 403) {
        	// let auth_url = $window.location.origin + $window.location.pathname + '#!/login';               
        	localStorage.removeItem('token');                       
            // $window.location.replace(auth_url);            
            if (!$rootScope.redirected){
                let next =  $location.path();                           
                $location.path('/login' + next);
                $rootScope.redirected = true
            }            
            return $q.reject(rejection);                        
        }
        return $q.reject(rejection);
    }   
    }    
}

AuthenticationInterceptor.$inject = ['$q', '$window', '$location', '$rootScope'];


// WEBPACK FOOTER //
// ./app/js/services/authenticationInterceptor.js